import React from 'react';
import findResult, { isEmpty } from '@/utils/resultsHelper';
import { readStates, saveStates } from '@/constants/lifecycle';
import TabActions from '@/components/tabs/TabActions';
import { canChangeDatasetFoundations } from '../helper';
import { newDatasourceSettings } from '../datasource/state/state';
import { datasetPerms } from '../sharing/state/state';
import { testDatasourceSettings, updateDatasourceSettings } from '../datasource/actions';
import {
  createDataset,
  finishDatasetWizard,
  updataDatasetValidationErrors,
  updateActiveDatasetStep,
  updateDataset,
  updateDatasetCatalogue,
} from '../actions';
import { resolveCatalogueTemplate, sectionsWithFields } from '../catalogue/helper';
import { datasetSettingsFields } from '../settings/state/state';
import { datasetDirtyFlags, datasetSourceAndStepAttributes } from '../state/state';
import { ShowDatasetTypeConfirmationWizard } from '../settings/actions';
import hasDatasourceChanged from '../datasource/helper';

const DatasetWizardActionsContainer = ({ children }) => (
  <TabActions className="aridhia-dataset-wizard-actions">
    {children}
  </TabActions>
);

export const mapStateToProps = ({
  auth: { role: { permissions } },
  datasetDatasource: { settings },
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const datasourceSettings = findResult(settings, ownProps.category, ownProps.code) || newDatasourceSettings(ownProps);
  const { dataset, template, editable } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    catalogue: { title: '' },
    copy: { catalogue: { title: '' } },
    dictionaries: [],
    isDirty: datasetDirtyFlags(),
    permissions: datasetPerms(),
    steps: datasetSourceAndStepAttributes(),
    ...readStates,
    ...saveStates,
    settings: datasetSettingsFields(),
  });
  const {
    steps, isNew, readErrors, saveErrors, saveStatus, copy, catalogue,
  } = dataset;

  const { canChangeDatasource } = canChangeDatasetFoundations(dataset, permissions);
  const isDirty = {
    ...dataset.isDirty,
    datasource: hasDatasourceChanged(datasourceSettings, datasourceSettings.copy),
    template: !isEmpty(steps.templateCode) && (steps.templateCode !== dataset.settings.catalogue_definition_code),
  };

  if (!template.code) {
    template.code = dataset.settings.catalogue_definition_code;
    template.name = steps.templateName;
  }

  return ({
    activeStepIndex: steps.activeStepIndex,
    canChangeDatasource,
    dataset,
    datasetCode: steps.code,
    datasourceSettings,
    disableEdit: !editable,
    isDirty,
    isNew,
    previousTitle: copy.catalogue?.title,
    readErrors: readErrors.concat(template.readErrors),
    saveErrors,
    saveStatus,
    sectionsWithFields: sectionsWithFields(template),
    template,
    title: catalogue.title,
  });
};

export const mapDispatchToProps = {
  confirmTypeChange: ShowDatasetTypeConfirmationWizard,
  finishDataset: finishDatasetWizard,
  create: createDataset,
  testSettings: testDatasourceSettings,
  update: updateDataset,
  updateCatalogue: updateDatasetCatalogue,
  updateDatasourceSettings,
  updateErrors: updataDatasetValidationErrors,
  updateStep: updateActiveDatasetStep,
};

export default DatasetWizardActionsContainer;
